import { http } from "./http";

/** Global permission-group management (admin-only). */

export interface PermissionGroup {
  portalPermissionGroupId: number;
  name: string;
  permissionCount: number;
  loginCount: number;
}

export interface GroupPermission {
  portalPermissionId: number;
  name: string;
  loginType: string;
  description: string;
  assigned: boolean;
}

const base = "/api/admin/permission-groups";

export const permissionGroupsApi = {
  list: () => http<PermissionGroup[]>(base),

  create: (name: string) =>
    http<PermissionGroup[]>(base, {
      method: "POST",
      body: JSON.stringify({ name }),
    }),

  rename: (groupId: number, name: string) =>
    http<PermissionGroup[]>(`${base}/${groupId}`, {
      method: "PUT",
      body: JSON.stringify({ name }),
    }),

  remove: (groupId: number) =>
    http<PermissionGroup[]>(`${base}/${groupId}`, { method: "DELETE" }),

  permissions: (groupId: number) =>
    http<GroupPermission[]>(`${base}/${groupId}/permissions`),

  addPermission: (groupId: number, permissionId: number) =>
    http<GroupPermission[]>(`${base}/${groupId}/permissions/${permissionId}`, {
      method: "POST",
    }),

  removePermission: (groupId: number, permissionId: number) =>
    http<GroupPermission[]>(`${base}/${groupId}/permissions/${permissionId}`, {
      method: "DELETE",
    }),
};
